var CampaignType;
(function (CampaignType) {
    CampaignType["MembershipRewardCampaign"] = "promoteBrandClubRewardCampaign";
    CampaignType["PurchaseRewardCampaign"] = "purchaseRewardCampaign";
    CampaignType["SurveyRewardCampaign"] = "surveyRewardCampaign";
    CampaignType["DailyDealsRewardCampaign"] = "limitedTimePurchaseRewardCampaign";
    CampaignType["RatingCampaign"] = "reviewRewardCampaign";
    CampaignType["AffiliateRewardCampaign"] = "affiliateLinkCampaign";
    CampaignType["ContentRewardCampaign"] = "contentRewardCampaign";
    CampaignType["ReferralRewardCampaign"] = "referralRewardCampaign";
    CampaignType["RetailerConnectRewardCampaign"] = "retailerConnectRewardCampaign";
})(CampaignType || (CampaignType = {}));
var BrandclubEntityType;
(function (BrandclubEntityType) {
    BrandclubEntityType["Audience"] = "audience";
    BrandclubEntityType["Brand"] = "brand";
    BrandclubEntityType["Category"] = "category";
    BrandclubEntityType["Subcategory"] = "subCategory";
    BrandclubEntityType["CustomCategoryGroup"] = "customCategoryGroup";
    BrandclubEntityType["Campaign"] = "campaign";
    BrandclubEntityType["CompanyDivision"] = "companyDivision";
    BrandclubEntityType["Customer"] = "customer";
    BrandclubEntityType["Product"] = "product";
    BrandclubEntityType["Reward"] = "reward";
    BrandclubEntityType["Profile"] = "profile";
})(BrandclubEntityType || (BrandclubEntityType = {}));

export { BrandclubEntityType, CampaignType };
//# sourceMappingURL=Campaign.js.map
